import { useWindowVirtualizer } from '@tanstack/react-virtual';
import classNames from 'classnames';
import { Children, cloneElement, isValidElement } from 'react';
import { List, ListProps } from 'yoso';
import styles from './VirtualList.module.scss';

export type VirtualListProps = ListProps;
export const VirtualList = ({ className, children, style, ...props }: VirtualListProps) => {
  const virtualizer = useWindowVirtualizer({
    count: Children.count(children),
    estimateSize: () => 1,
    overscan: 2,
  });
  const childrenArray = Children.toArray(children);
  return (
    <List
      className={classNames(styles.root, className)}
      {...props}
      style={{ ...style, height: virtualizer.getTotalSize() }}>
      {virtualizer.getVirtualItems().map(({ index, key, start }) => {
        const child = childrenArray[index];
        if (isValidElement<JSX.IntrinsicElements['li']>(child)) {
          return cloneElement<any>(child, {
            key,
            ref: virtualizer.measureElement,
            className: classNames(child.props.className, styles.item),
            style: {
              ...child.props.style,
              transform: `translateY(${start}px)`,
            },
            'data-index': index,
          });
        }
      })}
    </List>
  );
};
